import { useMediaQuery } from 'react-responsive';

export const usePrefersReducedMotion = () => useMediaQuery({ query: '(prefers-reduced-motion: reduce)' });
